import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-5e7978f4"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "custom-dialog van-dialog"
};
var _hoisted_2 = {
  class: "dialog-title van-dialog__header van-dialog__header--isolated"
};
var _hoisted_3 = {
  class: "dialog-content"
};
var _hoisted_4 = {
  key: 0,
  class: "dialog-footer van-hairline--top van-dialog__footer"
};
var _hoisted_5 = {
  key: 0,
  type: "button",
  class: "van-button van-button--default van-button--large van-dialog__cancel"
};
var _hoisted_6 = {
  class: "van-button__content"
};
var _hoisted_7 = {
  class: "van-button__text"
};
var _hoisted_8 = {
  key: 1,
  type: "button",
  class: "van-button van-button--default van-button--large van-dialog__confirm van-hairline--left"
};
var _hoisted_9 = {
  class: "van-button__content"
};
var _hoisted_10 = {
  class: "van-button__text"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return $props.dialogShow ? (_openBlock(), _createElementBlock("div", {
    class: "dialog-container",
    key: $props.key
  }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, _toDisplayString($props.title), 1), _createElementVNode("div", _hoisted_3, [_renderSlot(_ctx.$slots, "default", {}, undefined, true)]), $props.showCancelBtn || $props.showConfirmBtn ? (_openBlock(), _createElementBlock("div", _hoisted_4, [$props.showCancelBtn ? (_openBlock(), _createElementBlock("button", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t('message.sleep.compare.cancel')), 1)])])) : _createCommentVNode("", true), $props.showConfirmBtn ? (_openBlock(), _createElementBlock("button", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t('message.sleep.compare.confirm')), 1)])])) : _createCommentVNode("", true)])) : _createCommentVNode("", true)]), _createElementVNode("div", {
    class: "van-overlay",
    onClick: _cache[0] || (_cache[0] = function () {
      return $options.clickMask && $options.clickMask.apply($options, arguments);
    })
  })])) : _createCommentVNode("", true);
}